/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendSubscriptionDto } from '../../models/backend-subscription-dto';

export interface SubscriptionActiveRetrieve$Params {}

export function subscriptionActiveRetrieve(
  http: HttpClient,
  rootUrl: string,
  params?: SubscriptionActiveRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendSubscriptionDto>> {
  const rb = new RequestBuilder(rootUrl, subscriptionActiveRetrieve.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendSubscriptionDto>;
    }),
  );
}

subscriptionActiveRetrieve.PATH = '/api/subscription/active/';
